import flatpickr from "flatpickr";
// import "flatpickr/dist/flatpickr.min.css";

import JustValidate from 'just-validate';
import SlimSelect from 'slim-select'
import intlTelInput from 'intl-tel-input';

import { startTimer, startTimerFromEndDate } from './timer.js';

import VilniusUniversitiesAndFaculties from './../../../public/vilnius_universities.json';
import RigaUniversitiesAndFaculties from './../../../public/riga_universities.json';
import KrakowUniversitiesAndFaculties from './../../../public/krakow_universities.json';
import WarsawUniversities from './../../../public/warsaw_universities.json';
import WarsawFaculties from './../../../public/warsaw_faculties.json';

const checkoutForm = document.getElementById('checkoutForm');
let validator;

let personCapacity = 1;

let discountCode = null;

document.addEventListener('DOMContentLoaded', ()=>{
    const checkoutPage = document.querySelector('body.page-template-page-checkout-short');

    if (!checkoutPage)
        return;


    //GENERAL:
    const bookingId = document.querySelector('main#main').dataset.bookingId;

    const html = document.documentElement;
    const currentCity = generalObject.currentCity;


    //SET UNIVERSITIES AND FACULTIES
    const allFaculties = [];
    let universities = [];

    const citiesForDocumentNumberField = ['krakow', 'warsaw'];



    if (checkoutForm)
        validator = new JustValidate('#checkoutForm');


    let booking; // ??


    fetchBooking();



    const createPersonModule = (personId, dependencies) => {
        const { validator, universities, countries, dateRange } = dependencies;

        // Private state - only this module can access
        let facultySlimSelect = null;
        let universitySlimSelect = null;
        let nationalitySlimSelect = null;
        let birthdayCalendar = null;

        // Cache DOM elements with person-specific selectors
        const elements = {
            nationalitySelect: () => document.querySelector(`#${personId}-nationality`),
            genderSelect: () => document.querySelector(`#${personId}-gender`),
            phoneInput: () => document.querySelector(`#${personId}-phone`),
            birthdayInput: () => document.querySelector(`#${personId}-birthday`),

            stayPurposeSelect: () => document.querySelector(`#${personId}-stay-purpose`),

            ageModal: () => document.querySelector(`#${personId}-age-modal`),
            privacyPolicyModal: ()=> document.querySelector(`#${personId}-privacy-policy-modal`),
            privacyPolicyCheckbox: () => document.querySelector(`#${personId}-privacy-policy`),
            // documentNumberInput: () => document.querySelector(`#${personId}-document-number`)
        };

        const initValidation = () => {
            const validationRules = [
                { field: 'name', rules: [
                        {
                            rule: 'required',
                            errorMessage: 'Name is required'
                        },
                        {
                            rule: 'maxLength',
                            value: 64,
                            errorMessage: 'Name cannot exceed 64 characters'
                        }
                    ] },
                { field: 'last-name',
                    rules: [
                        {
                            rule: 'required',
                            errorMessage: 'Surname is required'
                        },
                        {
                            rule: 'maxLength',
                            value: 64,
                            errorMessage: 'Surname cannot exceed 64 characters'
                        }
                    ] },
                { field: 'email',
                    rules: [
                        { rule: 'required' },
                        { rule: 'email' },
                        {
                            rule: 'maxLength',
                            value: 64,
                            errorMessage: 'Email cannot exceed 64 characters'
                        }
                    ] },
                { field: 'phone', rules: [{ rule: 'required', errorMessage: 'Phone is required' }] },
                { field: 'address', rules: [{ rule: 'required', errorMessage: 'Address is required' }] },
                { field: 'nationality',
                    rules: [
                        {
                            rule: 'required',
                            errorMessage: 'Nationality is required'
                        },
                        {
                            rule: 'maxLength',
                            value: 1024,
                            errorMessage: 'Nationality cannot exceed 1024 characters'
                        }
                    ] },
                { field: 'birthday', rules: [{ rule: 'required', errorMessage: 'Birthday is required' }] },
                // { field: 'gender', rules: [{ rule: 'required', errorMessage: 'Gender is required' }] },
                { field: 'stay-purpose', rules: [{ rule: 'required', errorMessage: 'Stay purpose is required' }] },
                {field: 'marketing', rules: [{rule: 'required', errorMessage: ' '}]},
                {field: 'privacy-policy', rules: [{rule: 'required', errorMessage: ' '}]}
                // { field: 'arrival-date', rules: [{ rule: 'required', errorMessage: 'Arrival date is required' }] }
            ];


            validationRules.forEach(({ field, rules }) => {
                validator.addField(`#${personId}-${field}`, rules);
            });
        };



        const initAgeValidation = () => {

            const ageModal = elements.ageModal();


            if (!ageModal) return;

            const cancelAgeModalButton = ageModal.querySelector('.cancel-age-modal');
            const acceptAgeModalButton = ageModal.querySelector('.accept-age-modal');
            const acceptAgeCheckbox = ageModal.querySelector(`#${personId}-accept-age`);


            if (!acceptAgeCheckbox) return;

            const validateAge = (birthDate) => {
                if (!birthDate) return;

                const currentDate = new Date();
                let age = currentDate.getFullYear() - birthDate.getFullYear();

                const monthDiff = currentDate.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
                    age--;
                }

                if (age < 18) {
                    toggleAgeModal();
                }
            };

            const toggleAgeModal = () => {
                if (ageModal.classList.contains('hidden')) {
                    ageModal.classList.remove('hidden');
                    acceptAgeCheckbox.checked = false;
                    acceptAgeModalButton.classList.add('is-disabled');
                } else {
                    ageModal.classList.add('hidden');
                }
            };

            // Event listeners
            acceptAgeCheckbox.addEventListener('change', () => {
                const wrapper = acceptAgeCheckbox.closest('.age-checkbox-wrapper');
                if (acceptAgeCheckbox.checked) {
                    wrapper.classList.remove('has-error');
                    acceptAgeModalButton.classList.remove('is-disabled');
                } else {
                    wrapper.classList.add('has-error');
                    acceptAgeModalButton.classList.add('is-disabled');
                }
            });

            acceptAgeModalButton.addEventListener('click', () => {
                const wrapper = acceptAgeCheckbox.closest('.age-checkbox-wrapper');

                if (acceptAgeCheckbox.checked) {
                    wrapper.classList.remove('has-error');
                    toggleAgeModal();
                } else {
                    wrapper.classList.add('has-error');
                }
            });

            cancelAgeModalButton.addEventListener('click', () => {
                if (birthdayCalendar) {
                    birthdayCalendar.clear();
                }
                toggleAgeModal();
            });

            // Initialize birthday calendar with age validation
            if (elements.birthdayInput()) {
                birthdayCalendar = flatpickr(`#${personId}-birthday`, {
                    enable: [
                        {
                            from: "1900-01-01",
                            to: "today"
                        }
                    ],
                    onReady: function(_, __, fp) {},
                    onChange: function(selectedDates, dateStr, instance) {},
                    onClose: function(selectedDates, dateStr, instance) {
                        validateAge(selectedDates[0]);
                    }
                });
            }
        };


        const initPrivacyValidation = () =>{
            const modal = elements.privacyPolicyModal();


            if (!modal) return;


            const privacyPolicyCheckbox = elements.privacyPolicyCheckbox();

            const agreeButton = modal.querySelector(`#${personId}-agree-button`);
            const cancelButton = modal.querySelector(`#${personId}-cancel-button`);
            const policyContainer = modal.querySelector(`#${personId}-policy-container`);

            let hasScrolledToBottom = false;


            // Show modal
            function showPrivacyPolicy(event) {
                if (event) event.preventDefault();
                modal.style.display = 'flex';
                policyContainer.scrollTop = 0;
                agreeButton.disabled = true;
                // scrollNotice.style.display = 'block';
                hasScrolledToBottom = false; // Reset scroll state when modal opens

                html.classList.add('no-scroll')
            }

            // Check if user has scrolled to the bottom
            function checkScrollPosition() {
                const scrollPosition = policyContainer.scrollTop;
                const scrollHeight = policyContainer.scrollHeight;
                const containerHeight = policyContainer.clientHeight;

                if (scrollPosition + containerHeight >= scrollHeight - 20) {
                    agreeButton.disabled = false;
                    // scrollNotice.style.display = 'none';
                    agreeButton.classList.add('enabled');
                    hasScrolledToBottom = true; // Set flag when user has scrolled to bottom
                }
            }

            // Close the modal
            function closeModal() {
                modal.style.display = 'none';
                html.classList.remove('no-scroll')
            }

            // Event listeners for modal
            policyContainer.addEventListener('scroll', checkScrollPosition);

            privacyPolicyCheckbox.addEventListener('click', (e)=>{
                e.preventDefault();
                showPrivacyPolicy();
            });


            agreeButton.addEventListener('click', function() {
                // Check if user has actually scrolled to the bottom
                if (!hasScrolledToBottom) {
                    // If they haven't scrolled, keep the button disabled and show a message
                    agreeButton.disabled = true;

                    policyContainer.scrollTop = 0;
                    return;
                }

                // When user has legitimately scrolled and agrees, check the checkbox
                privacyPolicyCheckbox.checked = true;

                // Trigger change event for JustValidate to recognize
                const changeEvent = new Event('change', { bubbles: true });
                privacyPolicyCheckbox.dispatchEvent(changeEvent);

                // Store acceptance
                localStorage.setItem('privacyPolicyRead', 'true');
                closeModal();
            });

            cancelButton.addEventListener('click', function() {
                closeModal();
                // Uncheck the checkbox if they cancel
                privacyPolicyCheckbox.checked = false;

                // Trigger change event
                const changeEvent = new Event('change', { bubbles: true });
                privacyPolicyCheckbox.dispatchEvent(changeEvent);
            });
            //PRIVACY POLICY MODAL END

        }

        //INIT PHONE INPUT
        const initPhoneInput = () => {
            const phoneInput = elements.phoneInput();
            if (phoneInput){

                intlTelInput(phoneInput, {
                    hiddenInput: (telInputName) => ({
                        phone: `${personId}-phone-number`,
                    }),
                    separateDialCode: true,
                    initialCountry: 'auto',
                    geoIpLookup: callback => {
                        fetch("https://ipapi.co/json")
                            .then(res => res.json())
                            .then(data => callback(data.country_code))
                            .catch(() => callback("lt"));
                    },
                    autoPlaceholder: 'aggressive',
                    loadUtils: () => import("intl-tel-input/utils"),
                });
            }
        }


        const initSelects = () => {

            if (elements.nationalitySelect()) {
                nationalitySlimSelect = new SlimSelect({
                    select: `#${personId}-nationality`,
                    settings: { showSearch: true }
                });
            }


            // Gender select
            // if (elements.genderSelect()) {
            //     new SlimSelect({
            //         select: `#${personId}-gender`,
            //         settings: { showSearch: false }
            //     });
            // }

            if (elements.stayPurposeSelect()) {
                new SlimSelect({
                    select: `#${personId}-stay-purpose`,
                    settings: { showSearch: false }
                });
            }

            //where Did You Hear About Us select
            // if (elements.whereDidYouHearAboutUsSelect()) {
            //     new SlimSelect({
            //         select: `#${personId}-whereDidYouHearAboutUs`,
            //         settings: { showSearch: false }
            //     });
            // }
        };


        const init = () => {
            initValidation();
            initSelects();

            // initCalendars();
            initPhoneInput();
            initAgeValidation();
            initPrivacyValidation();
            // Run initial state
            // handleStayPurposeChange();
        };

        const destroy = () => {
            // Clean up all SlimSelect instances
            facultySlimSelect?.destroy();
            universitySlimSelect?.destroy();
        };

        // Public API
        return {
            init,
            destroy,
        };
    };

    const companyValidationRules = [
        {
            field: '#guest-company-name', rules: [
                {
                    rule: 'required',
                    errorMessage: 'Company name is required'
                },
                {
                    rule: 'maxLength',
                    value: 128,
                    errorMessage: 'Company name cannot exceed 128 characters'
                }
            ]
        },
        {
            field: '#guest-company-code', rules: [
                {
                    rule: 'required',
                    errorMessage: 'Company code is required'
                },
                {
                    rule: 'maxLength',
                    value: 64,
                    errorMessage: 'Company code cannot exceed 64 characters'
                }
            ]
        },
        {
            field: '#guest-company-vat-code', rules: [
                {
                    rule: 'maxLength',
                    value: 64,
                    errorMessage: 'Company VAT code cannot exceed 64 characters'
                }
            ]
        },
        {
            field: '#guest-company-address', rules: [
                {
                    rule: 'required',
                    errorMessage: 'Company address is required'
                }
            ]
        }
    ];


    companyValidationRules.forEach(({ field, rules }) => {
        validator.addField(`${field}`, rules);
    });





    // Create modules when needed
    const guestModule = createPersonModule('guest', {
        validator,
        universities,
        // countries
    });

    guestModule.init();



    //Company FIELDS
    const companyCheckbox = document.querySelector('#is-guest-company');
    const companyFieldsWrapper = document.querySelector('#companyFieldsWrapper');

    function updateCompanyValidation(){
        if (companyCheckbox.checked){

            companyFieldsWrapper.classList.remove('hidden');

            companyValidationRules.forEach(({ field, rules }) => {
                validator.addField(`${field}`, rules);
            });

        }else{
            validator.removeField('#guest-company-name')
            validator.removeField('#guest-company-code')
            validator.removeField('#guest-company-address')
            validator.removeField('#guest-company-vat-code')

            companyFieldsWrapper.classList.add('hidden');
        }

    }

    companyCheckbox.addEventListener('change', updateCompanyValidation)
    updateCompanyValidation()
    //Company FIELDS END


    //REMOVE BOOKING
    const removeBookingButtonShort = document.getElementById('removeBookingButtonShort');

    if (removeBookingButtonShort){
        removeBookingButtonShort.addEventListener('click', ()=>{
            const data = new FormData();

            data.append('action', 'removeBookingShort');
            data.append('booking_id', bookingId);
            data.append('nonce', ajaxObject.nonce);

            fetch(ajaxObject.ajax_url, {
                method: 'POST',
                body: data,
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    // console.log('Success:', data);
                    window.location.href = ajaxObject.rooms_url;

                })
                .catch(error => {
                    console.error('Error:', error);
                });
        });
    }
    //REMOVE BOOKING END



    validator.onSuccess((event) => {

        event.preventDefault();
        setTimeout(() => {
            // Get all form data
            const data = new FormData(document.getElementById('checkoutForm'));
            data.append('action', 'create_checkout');
            data.append('booking_id', bookingId);
            data.append('nonce', ajaxObject.nonce);

            data.append('term', 'short')
            data.append('discount', discountCode)

            const formObject = {};
            for (let [key, value] of data) {
                formObject[key] = value;
            }
            // console.log(formObject);
            // return;


            fetch(ajaxObject.ajax_url, {
                method: 'POST',
                body: data,
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    console.log('Success:', data);


                    if (data.message === 'BookingNothingToInvoice'){
                        const checkoutError = document.querySelector('.checkout-error');
                        if (checkoutError){
                            checkoutError.remove()
                        }

                        console.log(data.message)
                        const errorCode = document.createElement('div');
                        errorCode.className = 'checkout-error p-2 rounded-md overflow-hidden bg-red-1 mt-4';
                        errorCode.textContent = 'BookingNothingToInvoice.'

                        document.getElementById('checkoutShortPayWrapper').appendChild(errorCode);
                    }

                    if (data.payseraRequest){
                        const paymentURL = `${data.payseraRequest.url}?data=${data.payseraRequest.data}&sign=${data.payseraRequest.sign}`;
                        // console.log(paymentURL)

                        window.location.href = paymentURL;
                    }else if (data.autopayRequest?.url){

                        window.location.href = data.autopayRequest.url;
                    }


                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }, 10);
    });

    validator.onFail((event) =>{
        console.log('Error')

        const checkboxWrapperBookings = document.querySelectorAll('.checkbox-wrapper-booking');

        checkboxWrapperBookings.forEach(checkboxWrapper=>{
            const input = checkboxWrapper.querySelector('input')

            if (!input){
                return
            }

            if (input.checked){
                checkboxWrapper.classList.remove('has-error');
            }else{
                checkboxWrapper.classList.add('has-error');
            }
        })
    });



    //CHECKBOXES errors
    document.querySelectorAll('.checkbox-wrapper-booking input').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            const wrapper = checkbox.closest('.checkbox-wrapper-booking');
            if (checkbox.checked) {
                wrapper.classList.remove('has-error');
            } else {
                wrapper.classList.add('has-error');
            }
        });
    });



    const applyDiscountCodeButton = document.getElementById('applyDiscountCode');
    const discountCodeInput = document.getElementById('discountCode');


    discountCodeInput.addEventListener('input', ()=>{
        removeDiscountCodeMessage()

        if (discountCodeInput.value !== ''){
            applyDiscountCodeButton.disabled = false;
        }else{
            applyDiscountCodeButton.disabled = true;
        }
    });

    applyDiscountCodeButton.addEventListener('click', ()=>{


        const data = new FormData();
        const discountCode = discountCodeInput.value;

        data.append('action', 'apply_discount');
        data.append('nonce', ajaxObject.nonce);
        data.append('booking_id', bookingId);
        data.append('discount_code', discountCode)

        applyDiscountCode(data);
    })

    function removeDiscountCodeMessage(){
        const discountMessage = document.querySelector('.discount-message');
        if (discountMessage){
            discountMessage.remove()
        }
    }

    function applyDiscountCode(data){
        fetch(ajaxObject.ajax_url, {
            method: 'POST',
            body: data
        })
            .then(response=>{
                if (!response.ok) {
                    throw new Error(`[${response.status}] ${response.statusText}`);
                }
                return response.json();
            })
            .then(response => {
                console.log(response);

                let total = 0;
                let discountTotal = 0;

                removeDiscountCodeMessage()

                if (response.data?.pricing?.discountWithCodeInfo?.code === null){

                    const discountDiv = document.createElement('div');
                    discountDiv.className = 'discount-message p-2 rounded-md overflow-hidden bg-red-1 mt-4';
                    discountDiv.textContent = 'It appears that this discount code is invalid.'

                    document.getElementById('discountBlock').insertAdjacentElement('afterend', discountDiv);


                }else{
                    total = response.data.pricing.total;
                    discountTotal = response.data.pricing.discountWithCodeInfo.appliedAmount;
                    console.log(total)
                    console.log(discountTotal)

                    const discountDiv = document.createElement('div');
                    discountDiv.className = 'discount-message p-2 rounded-md overflow-hidden bg-green-1 mt-4';
                    discountDiv.textContent = 'Discount code applied.'

                    document.getElementById('discountBlock').insertAdjacentElement('afterend', discountDiv);

                }

                updateCheckoutPrices(response.data)



            })
            .catch(error => {
                console.error(error)
            })
    }


    function updateCheckoutPrices(data){

        console.log(data.pricing.discountWithCodeInfo)

        console.log(data.pricing.discountWithCodeInfo.appliedAmount)
        console.log(data.pricing.discountWithCodeInfo.code)

        const totalVat = document.getElementById('totalVat');
        const totalPrice = document.getElementById('totalPrice');


        if (data.pricing.discountWithCodeInfo.code == null){
            document.getElementById('discountInfoWrapper').innerHTML = '';
            discountCode = null;


            totalVat.innerText = Number(data.pricing.totalVAT).toFixed(2);

            totalPrice.innerText = Number(data.pricing.total).toFixed(2);

        }else{
            totalVat.innerText = Number(data.pricing.totalVAT).toFixed(2);

            totalPrice.innerText = Number(data.pricing.total).toFixed(2);

            discountCode = data.pricing.discountWithCodeInfo.code;

            document.getElementById('discountInfoWrapper').innerHTML += `
            <div class="flex justify-between text-lg mt-6">
                <p>Discount (${data.pricing.discountWithCodeInfo.code})</p>
                <p>-${data.pricing.discountWithCodeInfo.appliedAmount}€</p>
            </div>
        `;
        }







    }


    function fetchBooking(){
        const data = new FormData();

        data.append('action', 'get_booking');
        data.append('booking_id', bookingId);
        data.append('nonce', ajaxObject.nonce);
        data.append('term', 'short')

        fetch(ajaxObject.ajax_url, {
            method: 'POST',
            body: data
        })
            .then(response=>{
                if (!response.ok) {
                    throw new Error(`[${response.status}] ${response.statusText}`);
                }
                return response.json();
            })
            .then(response => {
                console.log(response);


                if (response?.expired) {
                    const submitBookingForm = document.getElementById('submit-booking-form');
                    submitBookingForm.disabled = true;
                    submitBookingForm.classList.add('button-disabled')
                }


                const groupedProducts = response?.productsGrouped;

                if (response?.expiresAt) {
                    const expirationDate = new Date(response?.expiresAt);

                    if (document.querySelector('#time')) {
                        // console.log(expirationDate)

                        // Use the timer functions from timer-utils.js
                        var display = document.querySelector('#time');

                        startTimerFromEndDate(expirationDate, display, function () {
                            timeExpired()
                        });
                    }
                }

            })
            .catch(error => {
                console.error(error)
            })
    }



    function timeExpired(){
        const timerExpiredModal = document.getElementById('timerExpiredModal');
        const submitBookingForm = document.getElementById('submit-booking-form');
        timerExpiredModal.classList.remove('hidden');
        timerExpiredModal.classList.add('flex');

        submitBookingForm.disabled = true;
        submitBookingForm.classList.add('button-disabled');


        let count = 9;
        const display = document.getElementById('backToMainPageTime');
        const timer = setInterval(() => {
            display.textContent = count;
            if (count === 0) {
                clearInterval(timer);
                window.location.href = ajaxObject.rooms_url;
            }
            count--;
        }, 1000);

    }

})